import { MantineThemeOverride } from '@mantine/core';

export type ChipTheme = NonNullable<MantineThemeOverride['components']>['Chip'];

export const Chip: ChipTheme = {
  // todo: define
};
